module.exports = __webpack_public_path__ + "9d745947.png";